import { render, staticRenderFns } from "./ConfirmRegistration.vue?vue&type=template&id=474ce4ca&"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports